export default "__VITE_ASSET__B0tT2KAP__"